(function (global) {
  'use strict';

  /**
   * Debounce function.
   *
   * @param {Function} func Function fot to peforme.
   * @param {Number} timeout Timeout in milisseconds
   * @returns {Null}
   */
  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  class MobileNavigation extends HTMLElement {
    constructor() {
      super();

      this.closeMobileMenu = this.querySelector('.mobile-navigation__button-close');
      this.menuButton = Array.from(document.querySelectorAll('[aria-controls="menu-mobile"]'));
      this.superLinks = Array.from(
        this.querySelectorAll('.mobile-navigation__menu-item--has-child > .mobile-navigation__item-link')
      );
      this.menuBlockTitle = Array.from(
        this.querySelectorAll('.mobile-navigation__menu-block > .mobile-navigation__item-title')
      );
      this.menuButtonListener = this._menuButton.bind(this);
      this.openSubmenuListener = this._openSubmenu.bind(this);
      this.closeMenuBlockListener = this._closeMenuBlock.bind(this);
      this.closeMobileMenuListener = this._closeMobileMenu.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-navigation')) {
          this._closeMobileMenu();
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeMobileMenu();
        }
      });
      this.closeMobileMenu.addEventListener('click', this.closeMobileMenuListener);
      this.menuButton.forEach((button) => {
        button.addEventListener('click', this.menuButtonListener);
      });
      this.superLinks.forEach((link) => {
        link.addEventListener('click', this.openSubmenuListener);
      });
      this.menuBlockTitle.forEach((title) => {
        title.addEventListener('click', this.closeMenuBlockListener);
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-navigation')) {
          this._closeMobileMenu();
        }
      });
      document.removeEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeMobileMenu();
        }
      });
      this.closeMobileMenu.removeEventListener('click', this.closeMobileMenuListener);
      this.menuButton.forEach((button) => {
        button.removeEventListener('click', this.menuButtonListener);
      });
      this.superLinks.forEach((link) => {
        link.removeEventListener('click', this.openSubmenuListener);
      });
      this.menuBlockTitle.forEach((title) => {
        title.removeEventListener('click', this.closeMenuBlockListener);
      });
    }
    _menuButton() {
      this.classList.add('active');
    }
    _closeMobileMenu() {
      this.classList.remove('active');

      setTimeout(() => {
        this.querySelectorAll('.active').forEach((el) => {
          el.classList.remove('active');
        });
      }, 300);
    }
    _openSubmenu(e) {
      e.preventDefault();

      const menuItem = e.currentTarget.parentNode;
      const menuBlock = e.currentTarget.closest('.mobile-navigation__menu-block');

      if (menuBlock && menuItem) {
        menuItem.classList.add('active');
        menuBlock.classList.add('active');
      }
    }
    _closeMenuBlock(e) {
      e.preventDefault();

      const menuItem = e.currentTarget.closest('.mobile-navigation__menu-item');
      const menuBlock = e.currentTarget.closest('.mobile-navigation__menu-block.active');

      if (menuBlock && menuItem) {
        menuItem.classList.remove('active');
        menuBlock.classList.remove('active');
      }
    }
  }
  if (!window.customElements.get('mobile-navigation')) {
    window.customElements.define('mobile-navigation', MobileNavigation);
  }

  class HeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.suggestions = this.querySelector('#search-results').innerHTML;
      this.input = this.querySelector('[name="q"]');
      this.typingListener = this._typing.bind(this);
      this.focusListener = this._focus.bind(this);
      this.buttonClose = this.querySelector('.header-search__button--close');
      this.closeSearchListener = this._closeSearch.bind(this);
      this.termClickListener = this._termClick.bind(this);
    }
    connectedCallback() {
      this.input.addEventListener('input', debounce(this.typingListener));
      this.input.addEventListener('focus', this.focusListener);
      this.buttonClose.addEventListener('click', this.closeSearchListener);
      document.addEventListener('click', (e) => {
        if (!e.target.classList.contains('search-suggestion')) {
          if (!e.target.closest('.header-search')) {
            this._closeSearch(e);
          }
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeSearch(e);
        }
      });
      document.addEventListener('term:click', this.termClickListener);
    }
    _termClick(e) {
      e.preventDefault();

      this.input.value = e.detail.term;
      this._request(this.input.value);
    }
    _closeSearch(e) {
      this.classList.remove('active');
    }
    _searching() {
      return '<div class="header-search__no-type"><p class="search-results__loading"><span class="spinner"></span>Buscando resultados...</p></div>';
    }
    _focus(e) {
      this.classList.add('active');
    }
    _serchSuggestionList() {
      return this.suggestions;
    }
    _request(term){
      const results = this.querySelector('#search-results');

      if (this.input.value === '') {
        results.innerHTML = this._serchSuggestionList();
        return;
      }

      results.innerHTML = this._searching();

      fetch(
        window.Shopify.routes.root +
          'search/suggest?q=' +
          term +
          '&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search',
        {
          method: 'GET',
        }
      )
        .then((r) => r.text())
        .then((result) => {
          const resultHtml = new DOMParser().parseFromString(result, 'text/html');
          this.querySelector('#search-results').replaceWith(
            document.importNode(resultHtml.querySelector('#shopify-section-predictive-search'), true)
          );

          this.querySelector('.search-resilts__all-results > a').href = '/search?q=' + term;

          this.querySelector('.header-search__results-tab').click();
        })
        .catch((err) => {
          console.error(err);
        });
    }
    _typing(e) {
      e.preventDefault();

      this._request(this.input.value);
    }
  }
  if (!window.customElements.get('header-search')) {
    window.customElements.define('header-search', HeaderSearch);
  }

  class PredictiveSearchResults extends HTMLElement {
    constructor() {
      super();

      this.tabs = Array.from(this.querySelectorAll('.header-search__results-tab'));
      this.cards = Array.from(this.querySelectorAll('.predictive-search__result'));
      this.changeTabListener = this._changeTab.bind(this);
    }
    connectedCallback() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.changeTabListener);
      });
    }
    _changeTab(e) {
      e.preventDefault();

      const currentTab = e.currentTarget;
      const currentType = currentTab.dataset.type;

      this.tabs = this.tabs.map((tab) => {
        tab.classList.remove('active');

        return tab;
      });
      currentTab.classList.add('active');

      this.cards = this.cards.map((card) => {
        card.style.display = card.dataset.type === currentType ? 'block' : 'none';

        return card;
      });
    }
  }
  if (!window.customElements.get('predictive-search-results')) {
    window.customElements.define('predictive-search-results', PredictiveSearchResults);
  }


  class SearchSuggestion extends HTMLElement {
    constructor() {
      super();

      this.clickListener = this._click.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.clickListener);
    }
    _click(e) {
      e.preventDefault();

      document.dispatchEvent(new CustomEvent('term:click', {
        bubbles: true,
        detail: {
          term: this.innerText
        }
      }))
    }
  }
  if (!window.customElements.get('search-suggestion')) {
    window.customElements.define('search-suggestion', SearchSuggestion);
  }



  class XNewSlideshow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (typeof Splide === 'undefined') {
        const script = document.createElement('script');

        script.addEventListener('load', () => {
          this._run();
        });
        script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        script.defer = 'defer';

        document.body.appendChild(script);
      } else {
        this._run();
      }
    }
    _run() {
      new Splide(this,{
        type: 'fade',
        autoHeight: true
      }).mount();
    }
  }

  if (!window.customElements.get('x-new-slideshow')) {
    window.customElements.define('x-new-slideshow', XNewSlideshow);
  }

  /* Class for product shipping bar */
  class ProductShippingBar extends HTMLElement {
    constructor() {
      super();

      this.message = this.getAttribute('message');
      this.freeShippingMessage = this.getAttribute('free-shipping-message');
      this.threshold = parseFloat(this.getAttribute('threshold') || 0);
      this.updateCartListener = this._updateCart.bind(this);
    }
    connectedCallback() {
      document.addEventListener('cart:change', this.updateCartListener);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:refresh', this.updateCartListener);
    }
    _updateCart(e) {
      e.preventDefault();

      try {
        if (this.threshold > 0) {
          const messageHTML = this.querySelector('.product-form__free-shipping-bar-label');
          const { cart } = e.detail;

          if (cart.total_price >= this.threshold) {
            messageHTML.innerHTML = this.freeShippingMessage;
          } else {
            messageHTML.innerHTML = this.message;
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!global.customElements.get('product-shipping-bar')) {
    global.customElements.define('product-shipping-bar', ProductShippingBar);
  }



  class BasicSlideshow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (typeof Splide === 'undefined') {
        const script = document.createElement('script');

        script.addEventListener('load', () => {
          this._run();
        });
        script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        script.defer = 'defer';

        document.body.appendChild(script);
      } else {
        this._run();
      }
    }
    _run() {
      new Splide(this).mount();
    }
  }

  if (!window.customElements.get('basic-slideshow')) {
    window.customElements.define('basic-slideshow', BasicSlideshow);
  }


  class NewHeader extends HTMLElement {
    constructor() {
      super();

      this.scrolled = window.scrollY;
      this.onWheelListener = this._onWheel.bind(this);
      this.onResizeListener = this._onResize.bind(this);
      this.onScrollListener = this._onScroll.bind(this);
    }
    connectedCallback() {
      window.addEventListener('scroll', this.onScrollListener);
      window.addEventListener('wheel', this.onWheelListener);
      window.addEventListener('resize', this.onResizeListener);
    }
    _onScroll() {
      if (Math.abs(this.scrolled - window.scrollY) >= 10) {
        if (this.scrolled > window.scrollY) {
          this.classList.remove('small');
        } else {
          this.classList.add('small');
        }
      }

      this.scrolled = window.scrollY
    }
    _onWheel(e) {
      if (e.deltaY > 0) {
        this.classList.add('small');
      } else {
        this.classList.remove('small');
      }
    }
    _onResize() {
      if (window.scrollY) {
        this.classList.add('small');
      } else {
        this.classList.remove('small');
      }
    }
  }
  
  if (!window.customElements.get('new-header')) {
    window.customElements.define('new-header', NewHeader);
  }
  
  

  class LineItemButton extends HTMLElement {
    constructor() {
      super();
      
      this.button = this.querySelector('button');
      this.onClickListener = this._onClickListener.bind(this);
    }
    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.onClickListener)
      }
    }
    _onClickListener(e) {
      let quantity;

      e.preventDefault();

      const lineItem = this.closest('.line-item-quantity');
      const quantityInput = lineItem.querySelector('.quantity-input');
      const action = this.dataset.action;

      switch(action) {
        case 'minus':
          if (quantityInput.value == 1) {
            return;
          }

          quantity = parseInt(quantityInput.value);
          quantity--;
          quantity = Math.max(1, quantity);
          quantityInput.value = quantity;

          quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        break;
      
        case 'plus':
          quantity = parseInt(quantityInput.value);
          quantity++;
          quantityInput.value = quantity;
          quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        break;
      }
    }
  }
  
  if (!window.customElements.get('line-item-button')) {
    window.customElements.define('line-item-button', LineItemButton);
  }


  var CouponPopup = class extends HTMLElement {
    constructor() {
      super();

      this.closeBtn = this.querySelector('#closeBtn');
      this.copyBtn = this.querySelector('#copyBtn');
      this.buyBtn = this.querySelector('#buyBtn');
      this.copiedMessage = this.querySelector('#popover');
      this.cupomText = this.querySelector('#cupom').innerText;
      this.onLoadListener = this._onLoad.bind(this);
      this.onCloseListener = this._onClose.bind(this);
      this.onCopyListener = this._onCopy.bind(this);
      
      this.target = this.getAttribute('target');
      this.delay = this.getAttribute('delay');
    }
    connectedCallback() {
      this.onLoadListener();

      this.closeBtn.addEventListener('click', this.onCloseListener);
      this.copyBtn.addEventListener('click', this.onCopyListener);
    }
    _onLoad() {
      setTimeout(() => {
        this.classList.add('show');
      }, this.delay * 1000);
    }
    _onClose() {
      this.classList.remove('show');
    }
    _onCopy() {
      navigator.clipboard.writeText(this.cupomText);
      
      this.copiedMessage.style.display = 'inline-block';
      this.buyBtn.href = this.target;
    }
  }

  if (!window.customElements.get('coupon-popup')) {
    window.customElements.define('coupon-popup', CouponPopup);
  }

  

  class MenuAccordion extends HTMLElement {
    constructor() {
      super();

      this.onClickListener = this._onClick.bind(this);
    }
    connectedCallback() {
      this.querySelector('.new-footer__menu-title').addEventListener('click', this.onClickListener);
    }
    _open() {
      this.classList.add('open');
    }
    _close() {
      this.classList.remove('open');
    }
    _isOpened() {
      return this.classList.contains('open') === true;
    }
    _onClick(e) {
      e.preventDefault();

      if (window.innerWidth < 1024) {
        if (this._isOpened()) {
          this._close();
        } else {
          this._open();
        }
      }
    }
  }
  if (!window.customElements.get('menu-accordion')) {
    window.customElements.define('menu-accordion', MenuAccordion);
  }


  class OfferInstallments extends HTMLElement {
    constructor() {
      super();
    }
  }
  if (!window.customElements.get('offer-installments')) {
    window.customElements.define('offer-installments', OfferInstallments);
  }
})(window);
